import { CreditorState } from '@debbie/common/dist/creditor/index.js'
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import CaseTable from '@debbie/iris/dist/components/CaseTable.js'
import { Col, Row } from '@debbie/iris/dist/components/Grid/index.js'
import {
  Button,
  Content,
  PageBase,
  Panel,
  SubMenu,
  TopNav,
} from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'

const Cases = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const allCreditorsLoadable = useAllCreditors()
  const allCreditors = h.hasData(allCreditorsLoadable)
    ? allCreditorsLoadable.data
    : null
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  const creditor = allCreditors
    ? allCreditors.find((creditor) => creditor.creditorId === selectedCreditor)
    : null

  return (
    <div>
      <TopNav />
      <Content withSubMenu>
        <PageBase>
          <SubMenu
            items={[
              {
                text: lang.navigation.overview,
                link: '/',
              },
              {
                text: lang.navigation.cases,
                link: '/cases',
              },
            ]}
          >
            <div
              style={{
                display: 'inline-block',
                verticalAlign: 'bottom',
              }}
            >
              {allCreditors && [0] && creditor && (
                <>
                  <div
                    data-tooltip-content={
                      creditor.state === CreditorState.Ceased
                        ? lang.cases.missingCreateAccess
                        : null
                    }
                    data-tooltip-id="tooltip-left"
                  >
                    <Button
                      size="small"
                      disabled={creditor.state === CreditorState.Ceased}
                      href="/create-case"
                    >
                      {lang.cases.createNewCase}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </SubMenu>
          <Row>
            <Col size="md" width="12">
              <Panel header={lang.cases.caseOverview}>
                <CaseTable />
              </Panel>
            </Col>
          </Row>
        </PageBase>
      </Content>
    </div>
  )
}

export default Cases
